import RRHHCertificatesView from '@/requests/certificates/employmentCertificate/views/rrhh/viewRRhhh'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/requests/viewCertifiesRequests/viewRrhh')({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }

    const { isRRHH } = context.userRoles;

    if (!isRRHH) {
      throw redirect({ to: '/unauthorized' });
    }
  },

  component: RRHHCertificatesView,

})

